import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '@/features/auth/AuthContext';
import Login from '@/features/auth/Login';
import ProtectedRoute from '@/features/auth/ProtectedRoute';
import EDeskLayout from '@/features/layout/EDeskLayout';
import MailboxView from '@/features/mailbox/MailboxView';
import EmailDetail from '@/features/ticket/EmailDetail';
import ApprovedQueue from '@/features/approved/ApprovedQueue';
import Dashboard from '@/features/dashboard/Dashboard';
import Settings from '@/features/settings/Settings';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route path="/" element={<MailboxView />} />
                    <Route path="/emails" element={<MailboxView />} />
                    <Route path="/review" element={<MailboxView />} />
                    <Route path="/review/:id" element={<EDeskLayout><EmailDetail /></EDeskLayout>} />
                    <Route path="/approved" element={<EDeskLayout><ApprovedQueue /></EDeskLayout>} />
                    <Route path="/dashboard" element={<EDeskLayout><Dashboard /></EDeskLayout>} />
                    <Route path="/settings" element={<EDeskLayout><Settings /></EDeskLayout>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
